import * as types from 'store/mutation-types'
import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
import {OPERATE_EXCEPTION} from 'static/message'
import {setLocalStore,getLocalStore} from 'util/util'
// initial state
const state = {
	//loading相关
	loadBottom:false,		//底部面板加载
	loadTree:false,			//左侧树load
	loadTabMap:false,		//右侧悬浮框load 
	loadCarRail:false,		//跟踪页面load
	//树和底部面板
	magnify:false,	//左侧树面板是否处于放大模式
	isChecked:false,  //左侧tabSearch
	checkedVehicle:[],//左侧tabSearch---选中的车辆分支id
	checkedVeObj:[],  //左侧tabSearch---选中的车辆分支信息
	deviceListComp:false,//是否显示设备一览组件
	vehicleDInfo:{},	//要查看设备一览的车辆信息
	//左侧树加载后的时间
	mountD:'',
	/*底部一览信息*/
	listInfo:{},				//底部一览信息
	/*关注面板信息*/
	followVehicleId:'',//被关注的车辆id
	followType:'',	 //是批量关注还是单车关注 
	tabFollowList:[],			//关注面板增删改操作的数组
	tabName:[],       			//下侧tabSelect---tab面板名称集合（关注车辆到原来面板时用到）
	curIndex:0,		 			//下侧tabSelect---tab索引
	//地图和右侧tabmap相关
	locateType:0,						//打开综合监控平台的方式  0 左侧菜单  2人保救援定位
	mapTabList:[],		//右侧悬浮框tabList
	mapIndex:0,						  //当前tab obj的No值
	mapTabTitle:'报警详情',			  	  //当前tab名称
	areaInfo:{},					  //围栏列表信息
	areaType:0,					      //区域类别--1 围栏，2路线，3标注
	delInfo:{},						  //删除弹框需要的信息
	routeInfo:{},					 //路线列表信息
	deletedObj:{},						//通过删除按钮删除的对象
	markerAdd:{},						//要显示到地图的标注地址
	delMarkerId:'',						//要删除的标注id
	fenceArr:[],						//要显示到地图的围栏坐标集合
	fenceID:'',							//围栏id
	delFenceID:'',						//要删除的围栏id
	routeArr:[],						//要显示到地图的路线坐标集合
	routeID:'',							//路线id
	delRouteID:'',						//要删除的路线id
	clearFlag:false,					//是否点击了删除按钮
	showDelModal:false,			//是否显示删除弹框
	showInstModal:false,		//是否显示指令弹框
	showFollowModal:false,		//是否显示关注弹框
	/*共用-提示弹框*/
	showTipModal:false,			//是否显示提示弹框
	tipContent:'',				//提示弹框内容
	locateOneInfo:[],			//单个车辆的定位信息
	locateAllInfo:[],			//多个车辆的定位信息
	//menuVehicle点报警
	curAlarmType:1,				//报警区域显示报警类型
	alarmTimer:{},				//报警区域轮巡显示报警数量
	alarmNum:[],				//几种报警类型分别多少条数据
	alarmList:[],				//各类报警的数据列表
	alarmDetail:{},				//点报警处理按钮获取到处理详情
	showSubPage:false,			//是否显示报警处理弹框
	showHomeSubPage:false,
	vDetail:{},					//点树车辆节点添加车辆详情标签
	//menuVehicle点命令
	cmdList:[],					//指令列表
	deviceList:[],				//设备列表
	checkedDevice:[],			//选中的设备id
	curInst:{},					//需要派发的指令信息
	curInstVInfo:{},			//派发命令的车辆信息
	next:true,					//派发命令处于第一步的弹框
	cmdStr:[],					//每次派发命令时的具体内容
	//追加轨迹队列
	gpsListInfo:{},				//轨迹回放页面的轨迹队列
	//跟踪窗口--PageCarRail.vue
	vehicles:[
		{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
		{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
		{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
		{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0}		
	],
	addCarToTrack:false,
	showCarTip:false,
	railTipCnt:'',
	timer:{},	//定时器
	//人保救援
	rescueInfo:{}, 
	/*监控平台收缩优化*/ 
	saveLayout:2,			//是否保存界面布局
	rightSize:getLocalStore('rightMode') =='' || getLocalStore('bottomMode') == null ? 0 : getLocalStore('rightMode'),	//右侧悬浮框默认最小  0最小，1半高，2最大
	leftSize:getLocalStore('leftMode')=='' || getLocalStore('bottomMode') ==  null ? 2 : getLocalStore('leftMode'),	//左侧悬浮框默认最大 0最小，1半高，2最大
	bottomSize:getLocalStore('bottomMode') == '' || getLocalStore('bottomMode') == null ? 1 : getLocalStore('bottomMode')  //底部悬浮框默认半高 0最小，1半高，2最大
}
const getters = {
	
}
// actions
const actions = {
	//判断是否保存界面布局
	savePageStyle({commit},no){
		commit('pageLayoutSave',no)
	},
	//更改右侧悬浮框大小
	changeRightSize({commit},num){
		commit('setRightSize',num)
	},
	//更改左侧悬浮框大小
	changeLeftSize({commit},num){
		commit('setLeftSize',num)
	},
	//更改底部悬浮框大小
	changeBottomSize({commit},num){
		commit('setBottomSize',num)
	},
	//resetState
	resetState({commit}){
		commit('resetMonitorState')
	},
	//load相关
	loadTreeList({commit},bool){
		commit(types.LOAD_TREE_LIST,bool)
	},
	loadingTabMap({commit},bool){
		commit(types.LOADING_TAB_MAP,bool)
	},
	loadingCarTab({commit},bool){
		commit(types.LOADING_CAR_TAB,bool)
	}, 
    //common
    clearAllList({commit}){//清空监控平台底部车辆一览和关注面板信息
  	   commit(types.CLEAR_ALL_LIST)
    },
    magnifyTree({commit},bool){
    	commit(types.MAGNIFY_TREE,bool)
    },
	checkVehicle({commit},obj) { //选中节点复选框
		commit(types.CHECKED_VEHICLE,obj)
	},
	removeVehicle({commit},id){//车辆一览里移出车辆
		commit(types.REMOVE_VEHICLE,id)
	},
	clearChecked({commit}){
		commit(types.CLEAR_CHECKED)
	},
	goPanel({commit},id){//底部面板切换tab
		commit(types.CHANGE_PANEL,id)	
	},
	goVehicleList({commit}){//底部面板切换tab
		commit(types.GO_LIST_PANEL)
	},
	saveMountTime({commit},str){//保存更新时间
		commit(types.SAVE_MOUNT_TIME,str)
	},
	showDeviceList({commit},obj){//打开设备一览
		commit(types.SHOW_DEVICE_LIST,obj)
	},
	closeDeviceList({commit}){
		commit(types.CLOSE_DEVICE_LIST)
	},
	//地图相关
	initMapTab({commit}){
		commit(types.INIT_MAP_TAB)
	},
	addMapTab({commit},obj){
		commit(types.ADD_MAP_TAB,obj)
	},
	goMapTab({commit},obj){
		commit(types.CHANGE_MAP_TAB,obj)
	},
	getAreaList({commit},param){//获取围栏、路线、标注列表
		commit(types.GET_AREA_LIST,param)
	},
	deleteArea({commit},obj){//删除围栏、路线、标注
		commit(types.DELETE_AREA,obj)
	},
	addressToPoint({commit},obj){
		commit(types.ADD_TO_POINT,obj)
	},
	removeMarker({commit},id){
		commit(types.REMOVE_MARKER,id)
	},
	fenceToMap({commit},obj){
		commit(types.FENCE_TO_MAP,obj)
	},
	removeFence({commit},id){
		commit(types.REMOVE_FENCE,id)
	},
	routeToMap({commit},obj){
		commit(types.ROUTE_TO_MAP,obj)
	},
	removeRoute({commit},id){
		commit(types.REMOVE_ROUTE,id)
	},
	clearMap({commit},bool){
		commit(types.CLEAR_MAP,bool)
	},
	//删除弹框部分
	deleteModalShow({commit},obj){
		commit(types.SHOW_DEL_MODAL,obj)
	},
	deleteModalHide({commit},obj){
		commit(types.HIDE_DEL_MODAL,obj)
	},
	//指令弹框部分
	instModalShow({commit},obj){
		commit(types.SHOW_INST_MODAL,obj)
	},
	instModalHide({commit}){
		commit(types.HIDE_INST_MODAL)
	},
	getCmdInfo({commit},arr){ //获取指令参数
		commit(types.GET_CMD_INFO,arr)
	},
	nextClickable({commit}){//点击取消
		commit(types.NEXT_CLICKABLE)
	},
	//关注弹框部分
	followModalShow({commit},obj){
		commit(types.SHOW_FOLLOW_MODAL,obj)
	},
	followModalHide({commit}){
		commit(types.HIDE_FOLLOW_MODAL)
	},
	//底部一览部分
	getVehicleList({commit},param){
		commit(types.GET_VEHICLE_LIST,param)
	},
	refreshVehicleList({commit},param){
		commit(types.REFRESH_VEHICLE_LIST,param)
	},
	//关注面板部分
	getFollowList({commit}){//关注车辆弹框->从原有关注面板中选择->获取原有关注面板信息
		commit(types.OLD_FOLLOW_PANELS)
	},
	getFollowPanel({commit},param){//关注新增完获取关注面板信息（含车辆）
		commit(types.GET_FOLLOW_PANEL,param)
	},
	getAllFollow({commit},id){
		commit(types.GET_ALL_FOLLOW,id)
	},
	refreshFollowPanel({commit},param){
		commit(types.REFRESH_FOLLOW_PANEL,param)
	},
	//公共--提示弹框部分
	tipModalShow({commit},tips){
		commit(types.SHOW_TIP_MODAL,tips)
	},
	tipModalHide({commit}){
		commit(types.HIDE_TIP_MODAL)
	},
	//在地图上定位-单个车辆-救援车辆
	locateOne({commit},vId){
		commit(types.LOCATE_ONE,vId)
	},
	//在地图上地位-迪迪专用
	locateVehicle({commit},param){
		commit('locateDidiVehicle',param)
	},
	//在地图上定位-全部面板批量车
	locateAll({commit},param){
		commit(types.LOCATE_ALL,param)
	},
	//关于右侧面板
	showAlarmInfo({commit},param){
		commit(types.SHOW_ALARM_INFO,param)
	},
	getAlarmDetail({commit},obj){
		commit(types.GET_ALARM_DETAIL,obj)
	},
	closeAlarmDetail({commit}){//关闭报警处理弹框
		commit(types.CLOSE_ALARM_DETAIL)
	},
	getAlarmNum({commit}){
		commit(types.GET_ALARM_NUM)
	},
	closeAlarmNum({commit}){
		commit(types.CLOSE_ALARM_NUM)
	},
	addVehicleDetail({commit},info){
		commit(types.ADD_VEHICLE_DETAIL,info)
	},
	//拉取指令列表
	getInstList({commit},param){
		commit(types.GET_INST_LIST,param)
	},
	insAllDevice({commit},obj){ //全选
		commit(types.INS_ALL_DEVICE,obj)
	},
	insOppDevice({commit},obj){//反选
		commit(types.INS_OPP_DEVICE,obj)
	},
	insRemoveAll({commit}){
		commit(types.INS_REMOVE_ALL)
	},
	insCheckedDevice({commit},dId){
		commit(types.INS_CHECKED_DEVICE,dId)
	},
	insRemovedDevice({commit},dId){
		commit(types.INS_REMOVED_DEVICE,dId)
	},
	//和跟踪窗口联动
	getTrackMap({commit}){//追加左侧跟踪地图
		commit(types.GET_TRACK_MAP)
	},
	showRailModal({commit},str){
		commit(types.SHOW_RAIL_MODAL,str)
	},
	hideRailModal({commit}){
		commit(types.HIDE_RAIL_MODAL)
	},
	notLoadToMap({commit}){
		commit(types.NOT_LOAD_TO_MAP)
	},
	//跟人保救援联动
	dataFromRescue({commit},info){
		commit(types.DATA_FROM_RESCUE,info)
	},  
	openByTab({commit},num){
		commit(types.OPEN_BY_TAB,num)
	},
	initComponent({commit}){
		commit('INIT_STATE')
	}
}

// mutations
const mutations = {
	pageLayoutSave(state,no){  
		state.saveLayout = no
		if(no == 0){
			mutations.SHOW_TIP_MODAL(state,'您确定要保存当前界面布局吗？')
			return
		}
		if(no == 2){
			state.leftSize = getLocalStore('leftMode')=='' || getLocalStore('bottomMode') ==  null ? 2 : getLocalStore('leftMode')
			state.bottomSize = getLocalStore('bottomMode') == '' || getLocalStore('bottomMode') == null ? 1 : getLocalStore('bottomMode')
			state.rightSize = getLocalStore('rightMode') =='' || getLocalStore('bottomMode') == null ? 0 : getLocalStore('rightMode')
			return
		}
		
		if(no == 1){
			setLocalStore('rightMode',state.rightSize)
			setLocalStore('leftMode',state.leftSize)
			setLocalStore('bottomMode',state.bottomSize)
			return
		}
	},
	setRightSize(state,num){
		state.rightSize = num 
	},
	setLeftSize(state,num){
		state.leftSize = num 
	},
	setBottomSize(state,num){
		state.bottomSize = num 
	},
	resetMonitorState(state){
		state.locateOneInfo = []
	},
	[types.LOAD_TREE_LIST](state,bool){
		state.loadTree = bool
	},
	[types.LOADING_TAB_MAP](state,bool){
		state.loadTabMap = bool
	},
	[types.LOADING_CAR_TAB](state,bool){
		state.loadBottom = bool
	}, 
	//清空监控平台底部车辆一览和关注面板信息
	[types.CLEAR_ALL_LIST](state){
	  	Vue.http.delete(process.env.API_ROOT + '/monitor/vehicle/vehicles/all')
	  	.then((res)=>{
	  		state.listInfo = res.body.data;
	  	},(res)=>{
	  		state.showTipModal = true;
			state.tipContent = res.body.message
	  	})
	  	.catch((res)=>{
	  		state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
	  	})
	},
	[types.MAGNIFY_TREE](state,bool){
		state.magnify = bool;
	},
	[types.CHECKED_VEHICLE](state,obj){//选中节点复选框
		state.isChecked = true;
		if(obj.type==2){
			const objTmp = state.checkedVehicle.find(n=>n.id === obj.id);
			if(objTmp === undefined){
				state.checkedVehicle.push(obj.id)
				state.checkedVeObj.push(obj)
			}
		}
	},
	[types.REMOVE_VEHICLE](state,obj){//车辆一览里移出车辆
		state.isChecked = false;
		if(obj.type==2){
			const index = state.checkedVehicle.findIndex(n=>n===obj.id);
			if(index != -1){
				state.checkedVehicle.splice(index,1);
				state.checkedVeObj.splice(index,1);
			}
		}
	},
	[types.CLEAR_CHECKED](state){
		state.checkedVeObj = []
		state.checkedVehicle = []
	},
	[types.CHANGE_PANEL](state,id){
		state.curIndex = id;
	},
	[types.GO_LIST_PANEL](state){
		state.curIndex = 0;
	},
	[types.SAVE_MOUNT_TIME](state,str){
		state.mountD = str
	},
	[types.SHOW_DEVICE_LIST](state,obj){
		state.vehicleDInfo = obj
		state.deviceListComp = true
	},
	[types.CLOSE_DEVICE_LIST](state){
		state.deviceListComp = false
	},
	//地图相关-
	[types.INIT_MAP_TAB](state){
		state.mapTabList = []
		state.mapIndex = 0
	},
	[types.ADD_MAP_TAB](state,obj){//点击增加tabmap选项卡
		//右侧悬浮框变成半高
		mutations.setRightSize(state,1)
		let objTmp = state.mapTabList.find(n=>n.id===obj.id)
		let tabObj = {
			id:obj.id,
			No:obj.No,
			name:obj.name
		}
		if(objTmp === undefined){
			state.mapTabList.splice(0,0,tabObj) 
			if(obj.No==1||obj.No==2||obj.No==3){
				const param = {
					page_index:1,
					areaType:obj.areaType,
					customerId:obj.groupId
				}
				mutations.GET_AREA_LIST(state,param)
			}
		}else{
			state.mapIndex = obj.No
			state.mapTabTitle = obj.name
		}
		state.mapIndex = obj.No
		state.mapTabTitle = obj.name
	},
	[types.CHANGE_MAP_TAB](state,obj){//切换右侧TabMap选项卡
		state.mapTabTitle = obj.name
		state.mapIndex = obj.No;
	},
	[types.GET_AREA_LIST](state,param){//获取围栏、路线、标注列表
		state.loadTabMap = true
		Vue.http.get(process.env.API_ROOT + '/monitor/areas/',{params:param})
		.then((res)=>{
			if(res.body.success){
				state.loadTabMap = false
				state.areaInfo = res.body.data
				state.areaType = param.areaType
			}
		},(res)=>{
			state.loadTabMap = false
			state.showTipModal = true;
			state.tipContent = res.body.message;
		})
		.catch((res)=>{
			state.loadTabMap = false
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.DELETE_AREA](state,obj){//删除围栏、路线、标注
		Vue.http.delete(process.env.API_ROOT + '/monitor/areas?areaId=' + obj.id)
		.then((res)=>{
			state.deletedObj = obj;
			state.showTipModal=true;
			state.tipContent="删除成功"
			const param = {
				page_index:1,
				areaType:state.delInfo.areaType,
				customerId:obj.groupId
			}
			mutations.GET_AREA_LIST(state,param)
		},(res)=>{
			state.showTipModal=true;
			state.tipContent=res.body.message
		})
		.catch((res)=>{
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;	
		})
	},
	[types.ADD_TO_POINT](state,obj){
		state.markerAdd = obj;
		state.delMarkerId = ''
	},
	[types.REMOVE_MARKER](state,id){
		state.delMarkerId = id
	},
	[types.FENCE_TO_MAP](state,obj){
		state.fenceArr = obj.points;
		state.fenceID = obj.id
		state.delFenceID = ''
	},
	[types.REMOVE_FENCE](state,id){
		state.delFenceID = id;
		state.fenceArr = []
	},
	[types.ROUTE_TO_MAP](state,obj){
		state.routeArr = obj.points;
		state.routeID = obj.id
		state.delRouteID = ''
	},
	[types.REMOVE_ROUTE](state,id){
		state.delRouteID = id
	},
	[types.CLEAR_MAP](state,bool){
		state.clearFlag = bool
	},
	//删除围栏或路线弹框
	[types.SHOW_DEL_MODAL](state,obj){
		state.showDelModal = true;
		state.delInfo = obj
	},
	[types.HIDE_DEL_MODAL](state){
		state.showDelModal = false;
	},
	//指令弹框部分
	[types.SHOW_INST_MODAL](state,obj){
		state.showInstModal = true;
		state.curInst = obj;
		state.next = true;
	},
	[types.HIDE_INST_MODAL](state){
		state.showInstModal = false;
	},
	[types.GET_CMD_INFO](state,arr){//获取指令参数
		state.cmdStr = arr
		state.next = false;
	},
	[types.NEXT_CLICKABLE](state){//(取消-确定)点取消
		state.next = true
	},
	[types.SHOW_FOLLOW_MODAL](state,obj){
		if(state.bottomSize==0){
			mutations.setBottomSize(state,1)
		}
		state.showFollowModal = true
		if(obj.type===0){
			state.followVehicleId = obj.id;
			state.followType = obj.type
		}
		state.followType = obj.type
	},
	//获取原有关注面板名称列表
	[types.OLD_FOLLOW_PANELS](state){
		Vue.http.get(process.env.API_ROOT + '/monitor/tagpanel/')
		.then((res)=>{
			if(res.body.success){
				const tagArr = res.body.data;
				state.tabName = tagArr;
			}
		},(res)=>{
			state.showTipModal = true;
			state.tipContent = res.body.message
		})
		.catch((res)=>{
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;			
		})
	},
	//获取关注面板信息--筛选、刷新、显示
	[types.GET_FOLLOW_PANEL](state,param){
		state.loadBottom = true;
		Vue.http.get(process.env.API_ROOT + '/monitor/tagpanel/'+ param.tagpanelId + '/page',{params:param.obj})
		.then((res)=>{
			state.loadBottom = false;	
			if(res.body.success){
				state.curIndex = param.tagpanelId;//跳转到对应面板
				let followInfo = res.body.data;//获取对应面板信息
				let index = state.tabFollowList.findIndex(n=>n.id==param.tagpanelId)
				state.tabFollowList[index].vehicleMonitorStatistics = followInfo
			}
		},(res)=>{
			state.loadBottom = false;
			state.showTipModal = true;
			state.tipContent = res.body.message
		})
		.catch((res)=>{
			state.loadBottom = false;
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.GET_ALL_FOLLOW](state,id){
		state.loadBottom = true
		Vue.http.get(process.env.API_ROOT + '/monitor/tagpanel/vehicles')
		.then((res)=>{
			state.loadBottom = false;	
			if(res.body.code=='200'){
				let val = res.body.data;
				for(let i = 0,length=val.length; i < length; i++){
					val[i].No = i + 1;
					if(val[i].vehicleMonitorStatistics!=null){
						val[i].isEmpty = false;
					}else{
						val[i].isEmpty = true;
					}
				}
				state.tabFollowList = val
				if(id){
					state.curIndex = id
				}
			}else{
				state.showTipModal = true;
				state.tipContent = res.body.message		
			}
		},(res)=>{
			state.loadBottom = false;
			state.showTipModal = true;
			state.tipContent = res.body.message
		})
		.catch((res)=>{
			state.loadBottom = false;	
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.REFRESH_FOLLOW_PANEL](state,param){//批量刷新
		state.loadBottom = true
		Vue.http.get(process.env.API_ROOT + '/monitor/tagpanel/' + param.tagpanelId + '/vehicles/',{params:param.obj})
		.then((res)=>{
			state.loadBottom = false
			if(res.body.code=='200'){
				state.curIndex = param.tagpanelId;//跳转到对应面板
				let obj = res.body.data
				let index = state.tabFollowList.findIndex(n=>n.id==obj.id)
				state.tabFollowList[index].vehicleMonitorStatistics = obj.vehicleMonitorStatistics
				if(obj.vehicleMonitorStatistics!=null){
					state.tabFollowList[index].isEmpty = false;
				}else{
					state.tabFollowList[index].isEmpty = true;
				}
				state.tabFollowList.splice(index,1,state.tabFollowList[index])
			}else{
				state.showTipModal = true;
				state.tipContent = res.body.message;		
			}
		},(res)=>{
			state.loadBottom = false	
			state.showTipModal = true;
			state.tipContent = res.body.message;
		})
		.catch((res)=>{
			state.loadBottom = false
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.HIDE_FOLLOW_MODAL](state){
		state.showFollowModal = false
	},
	//底部车辆一览部分
	[types.GET_VEHICLE_LIST](state,param){
		state.loadBottom = true;
		Vue.http.get(process.env.API_ROOT + '/monitor/vehicle/vehicles/page',{params:param})
		.then((response) => {
			if(response.body.success){
				state.loadBottom = false;
				const resObj = response.body.data
				state.listInfo = response.body.data
				state.curIndex = 0;
			}else{
				state.loadBottom = false;
				state.showTipModal = true;
				state.tipContent = response.body.message;
			}
		},(response)=>{
			state.loadBottom = false;
			state.showTipModal = true;
			state.tipContent = response.body.message;
		})
		.catch((response)=>{
			state.loadBottom = false;
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.REFRESH_VEHICLE_LIST](state,param){
		state.loadBottom = true
		Vue.http.get(process.env.API_ROOT + '/monitor/vehicle/vehicles/',{params:param})
		.then((response) => {
			state.loadBottom = false;
			if(response.body.success){
				const resObj = response.body.data
				state.listInfo = response.body.data
			}else{
				state.showTipModal = true;
				state.tipContent = response.body.message;
			}
		},(response)=>{
			state.loadBottom = false;
			state.showTipModal = true;
			state.tipContent = response.body.message;
		})
		.catch((response)=>{
			state.loadBottom = false;
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	//公共部分
	[types.SHOW_TIP_MODAL](state,tips){
		state.showTipModal = true;
		state.tipContent = tips;
		if(state.saveLayout!=0){
			setTimeout(()=>{
				mutations.HIDE_TIP_MODAL(state)
			},6000)
		}
		
	},
	[types.HIDE_TIP_MODAL](state){
		state.showTipModal = false;
	},
	//在地图上定位-单个车辆--救援车辆定位
	[types.LOCATE_ONE](state,vId){ 
		state.locateType = 1
		Vue.http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/vehicles/locatings/' + vId)
		.then((response) => {
			if(response.body.success){
				state.locateOneInfo = response.body.data
			}else{
				state.showTipModal = true
				state.tipContent = response.body.message		
			}
		},(response)=>{
			state.showTipModal = true
			state.tipContent = response.body.message	
			if(!response.body.message){
				state.tipContent = "请求出问题啦，请稍后重试"
			}
		})
		 
	},
	//在地图上定位-普通车辆-迪迪专用
	locateDidiVehicle(state,param){
		state.locateType = 1
		Vue.http.get(process.env.API_ROOT + '/monitor/locating/locatings/device',{params:param})
		.then((response) => {
			if(response.body.success){
				state.locateOneInfo = response.body.data
			}else{
				state.showTipModal = true
				state.tipContent = response.body.message		
			}
		},(response)=>{
			state.showTipModal = true
			state.tipContent = response.body.message	
			if(!response.body.message){
				state.tipContent = "请求出问题啦，请稍后重试"
			}
		})
	},
	//在地图上定位-全部面板的车辆
	[types.LOCATE_ALL](state,param){
		Vue.http.get(process.env.API_ROOT + '/monitor/locating/locatings/devices',{params:param})
		.then((response) => {
			if(response.body.success){
				state.locateAllInfo = response.body.data
			}else{
				state.showTipModal = true
				state.tipContent = response.body.message		
			}
		},(response)=>{
			state.showTipModal = true
			state.tipContent = response.body.message	
		})
		.catch((response)=>{
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.SHOW_ALARM_INFO](state,param){
		state.loadTabMap = true
		state.curAlarmType = param.almLevel
		Vue.http.get(process.env.API_ROOT + '/alarm/alarms/panel/',{params:param})
		.then((res)=>{
			state.loadTabMap = false
			state.alarmList = res.body.data;
		},(res)=>{
			state.loadTabMap = false
			state.showTipModal = true
			state.tipContent = response.body.message	
		})
		.catch((res)=>{
			state.loadTabMap = false
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;	
		})
	},
	[types.GET_ALARM_DETAIL](state,obj){
		Vue.http.get(process.env.API_ROOT + '/alarm/alarms/' + obj.alarmId)
			.then((res)=>{
				state.alarmDetail = res.body.data
				if(obj.source=='monitor'){
					state.showSubPage = true;
				}else{
					state.showHomeSubPage = true;
				}
			
			},(res)=>{
				state.showTipModal = true
				state.tipContent = response.body.message
			})
			.catch((res)=>{
				state.showTipModal = true;
				state.tipContent = OPERATE_EXCEPTION;
			})
	},
	[types.CLOSE_ALARM_DETAIL](state){
		state.showSubPage = false;
		state.showHomeSubPage = false;
	},
	[types.GET_ALARM_NUM](state){
		Vue.http.get(process.env.API_ROOT + '/alarm/alarms/user/msgcount?planOwnerType=1')
				.then((res)=>{
					state.alarmNum = res.body.data
				},(res)=>{
					state.showTipModal = true;
					state.tipContent = res.body.message;
				})
				.catch((res)=>{
					state.showTipModal = true;
					state.tipContent = OPERATE_EXCEPTION;
				})
		clearInterval(state.alarmTimer)
		state.alarmTimer = setInterval(function(){
			Vue.http.get(process.env.API_ROOT + '/alarm/alarms/user/msgcount?planOwnerType=1')
				.then((res)=>{
					state.alarmNum = res.body.data
				},(res)=>{
					state.showTipModal = true;
					state.tipContent = res.body.message;
				})
				.catch((res)=>{
					state.showTipModal = true;
					state.tipContent = OPERATE_EXCEPTION;
				})
		},60000)
	},
	[types.CLOSE_ALARM_NUM](state){
		clearInterval(state.alarmTimer)
	},
	[types.ADD_VEHICLE_DETAIL](state,info){
		state.vDetail = info;
	},
	[types.GET_INST_LIST](state,param){
		state.curInstVInfo = param.carInfo
		const obj = {
			vehicleId:param.carInfo.vehicleId
		}
		Vue.http.get(process.env.API_ROOT + '/monitor/instruction/instus/',{params:obj})
		.then((response) => {
			if(response.body.success){
				const obj = response.body.data
				state.cmdList = obj.cmdList;
				for(let i = 0,l = obj.deviceList.length; i < l; i ++){
					obj.deviceList[i].isChecked = false
				}
				state.checkedDevice = []
				state.deviceList = obj.deviceList
			}else{
				state.showTipModal = true
				state.tipContent = response.body.message		
			}
		},(response)=>{
				state.showTipModal = true
				state.tipContent = response.body.message	
		})
		.catch((response)=>{
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.INS_ALL_DEVICE](state,obj){//全选
		for(let i = 0,l = state.deviceList.length; i < l; i ++){
			if(state.deviceList[i].categoryId == obj.categoryId){
				state.deviceList[i].isChecked = true
				state.deviceList.splice(i,1,state.deviceList[i])
				const tmpIndex = state.checkedDevice.findIndex(n=>n==state.deviceList[i].id)
				if(tmpIndex==-1){
					state.checkedDevice.push(state.deviceList[i].id)
				} 
			}
		}
	},
	[types.INS_OPP_DEVICE](state,obj){//反选
		for(let i = 0,l = state.deviceList.length; i < l; i ++){
			if(state.deviceList[i].isChecked){
				state.deviceList[i].isChecked = false
				state.deviceList.splice(i,1,state.deviceList[i])
				mutations.INS_REMOVED_DEVICE(state,state.deviceList[i].id)
			}else{
				if(state.deviceList[i].categoryId == obj.categoryId){
					state.deviceList[i].isChecked = true
					state.deviceList.splice(i,1,state.deviceList[i])
					mutations.INS_CHECKED_DEVICE(state,state.deviceList[i].id)
				}
			}
		}
	},
	[types.INS_REMOVE_ALL](state){
		state.checkedDevice = []
	},
	[types.INS_CHECKED_DEVICE](state,dId){
		const tmpId = state.checkedDevice.find(n=>n==dId)
		if(tmpId==undefined){
			state.checkedDevice.push(dId)
		}
	},
	[types.INS_REMOVED_DEVICE](state,dId){
		const tmpIndex = state.checkedDevice.findIndex(n=>n==dId)
		if(tmpIndex!==-1){
			state.checkedDevice.splice(tmpIndex,1)
		}
	},
	//跟踪窗口追加地图
	[types.GET_TRACK_MAP](state){
		state.loadCarRail = true
		state.addCarToTrack = true
		Vue.http.get(process.env.API_ROOT + '/monitor/track/tracks/1')
		.then((res)=>{
			state.loadCarRail = false
			if(res.body.success){
				state.vehicles = [
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0}		
					]
				let obj = res.body.data
				if(obj!=null && obj.list.length != 0){
					for(let i=obj.list.length - 1;i >= 0;i --){
					let item = obj.list[i]
					let veh = state.vehicles.find(v => v.vehicleId == item.vehicleId);
					if(veh == undefined){
						let vehicle2Add = state.vehicles.find((v)=>v.valid==false);
						if(vehicle2Add == undefined){
							state.showTipModal = true;
							state.tipContent = '追踪队列已满';
							return;
						}
						vehicle2Add.lockFlg = item.lockFlg;
						vehicle2Add.vehicleId = item.vehicleId;
						vehicle2Add.ownerName = item.clientName;
						vehicle2Add.plateNumber = item.plateNumber;
						vehicle2Add.id = item.id;
						vehicle2Add.lng =item.lng;
						vehicle2Add.lat = item.lat;
						vehicle2Add.valid = true;	
					} 
					}
				}else{
					state.vehicles = [
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0},
					{vehicleId:'',checked:false,deviceId:105541,ownerName:'曹',plateNumber:'鲁B8888',id:'',lng: 120.39,lat: 36.073,valid:false,speed:0,locMode:'GPS',locSuccess:true,lockFlg:0}		
					]
				}
			}
		},(res)=>{
			state.addCarToTrack = false
			state.loadCarRail = false
			state.showTipModal = true;
			state.tipContent = res.body.message;
		})
		.catch((res)=>{
			state.addCarToTrack = false
			state.loadCarRail = false
			state.showTipModal = true;
			state.tipContent = OPERATE_EXCEPTION;
		})
	},
	[types.SHOW_RAIL_MODAL](state,str){
		state.showCarTip = true
		state.railTipCnt = str;
	},
	[types.HIDE_RAIL_MODAL](state){
		state.showCarTip = false
	},
	[types.NOT_LOAD_TO_MAP](state){
		state.addCarToTrack = false
	}, 
	[types.DATA_FROM_RESCUE](state,info){
		state.rescueInfo = info
	}, 
	[types.OPEN_BY_TAB](state,num){
		state.locateType = num
	},
	INIT_STATE(state){
		state.showTipModal = false
		state.tipContent = ''
		state.showDelModal= false			//是否显示删除弹框
		state.showInstModal=false		//是否显示指令弹框
		state.showFollowModal=false
	},
}

export default {
	state,
	actions,
	mutations,
	getters
}





// WEBPACK FOOTER //
// ./src/store/modules/monitor.js